import { diff_match_patch as DMPClass } from 'diff-match-patch';

export const diff_match_patch = DMPClass;
export type diff_match_patch = InstanceType<typeof DMPClass>;
export { DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL } from 'diff-match-patch';
